import React, { useState, useEffect } from 'react';

const UserDetailsModal = ({
                              isOpen,
                              onSubmit,
                              onCancel,
                              isSubmitting = false,
                              workoutType = 'custom',
                              trainerInfo = null
                          }) => {
    const [formData, setFormData] = useState({
        email: '',
        rememberMe: true
    });
    const [errors, setErrors] = useState({});

    // Load saved user data on mount
    useEffect(() => {
        const savedUserData = localStorage.getItem('bumfitUserData');
        if (savedUserData) {
            try {
                const userData = JSON.parse(savedUserData);
                setFormData({
                    email: userData.email || '',
                    rememberMe: true
                });
            } catch (e) {
                console.error('Error loading saved user data:', e);
            }
        }
    }, [isOpen]);

    const validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    const validatePhone = (phone) => {
        // Remove all non-digit characters
        const cleaned = phone.replace(/\D/g, '');
        // Check if it's 10 or 11 digits (US format)
        return cleaned.length === 10 || cleaned.length === 11;
    };

    const formatPhone = (phone) => {
        const cleaned = phone.replace(/\D/g, '');
        if (cleaned.length === 10) {
            return cleaned.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
        } else if (cleaned.length === 11 && cleaned[0] === '1') {
            return cleaned.replace(/(\d{1})(\d{3})(\d{3})(\d{4})/, '+$1 ($2) $3-$4');
        }
        return phone;
    };

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;

        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));

        // Clear error when user starts typing
        if (errors[name]) {
            setErrors(prev => ({
                ...prev,
                [name]: ''
            }));
        }
    };

    const validateForm = () => {
        const newErrors = {};

        if (!formData.email.trim()) {
            newErrors.email = 'Email is required';
        } else if (!validateEmail(formData.email)) {
            newErrors.email = 'Please enter a valid email address';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = () => {
        if (!validateForm()) {
            return;
        }

        // Save user data if remember me is checked
        if (formData.rememberMe) {
            localStorage.setItem('bumfitUserData', JSON.stringify({
                email: formData.email
            }));
        }

        onSubmit({
            email: formData.email,
            rememberMe: formData.rememberMe
        });
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleSubmit();
        }
    };

    if (!isOpen) return null;

    return (
        <div className="modal-overlay">
            <div className="user-details-modal">
                <div className="modal-header">
                    <h2>🔥 Get Your Workout!</h2>
                    <p className="modal-subtitle">
                        {trainerInfo?.isTrainerProgram
                            ? `Get "${trainerInfo.programName}" by ${trainerInfo.trainerName} sent to you instantly!`
                            : 'Get your custom workout sent to you instantly!'
                        }
                    </p>
                </div>

                <div className="modal-content">
                    <div className="input-group">
                        <label htmlFor="email">
                            <span className="label-text">Email Address</span>
                            <span className="required">*</span>
                        </label>
                        <input
                            id="email"
                            name="email"
                            type="email"
                            value={formData.email}
                            onChange={handleInputChange}
                            onKeyPress={handleKeyPress}
                            placeholder="your@email.com"
                            className={errors.email ? 'error' : ''}
                            disabled={isSubmitting}
                            autoComplete="email"
                            autoFocus
                        />
                        {errors.email && <span className="error-text">{errors.email}</span>}
                    </div>

                    <div className="checkbox-group">
                        <label className="checkbox-label">
                            <input
                                type="checkbox"
                                name="rememberMe"
                                checked={formData.rememberMe}
                                onChange={handleInputChange}
                                disabled={isSubmitting}
                            />
                            <span className="checkmark"></span>
                            <span className="checkbox-text">
                Remember me for next time
              </span>
                        </label>
                    </div>

                    <div className="delivery-info">
                        <h3>📧 What you'll receive:</h3>
                        <div className="delivery-methods">
                            <div className="delivery-item">
                                <span className="icon">📧</span>
                                <span>Email with complete workout details</span>
                            </div>
                            <div className="delivery-item">
                                <span className="icon">🎯</span>
                                <span>Exercise list with rep counts</span>
                            </div>
                            <div className="delivery-item">
                                <span className="icon">⚡</span>
                                <span>Instant delivery to your inbox</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal-buttons">
                    <button
                        type="button"
                        className="generate-button primary-button"
                        onClick={handleSubmit}
                        disabled={isSubmitting}
                    >
                        {isSubmitting ? (
                            <>
                                <span className="spinner"></span>
                                Generating...
                            </>
                        ) : (
                            <>
                                🔥 Get My Workout + Email
                            </>
                        )}
                    </button>

                    <button
                        type="button"
                        className="skip-button secondary-button"
                        onClick={() => {
                            onSubmit({
                                email: null,
                                skipEmail: true,
                                name: 'Fitness Enthusiast'
                            });
                        }}
                        disabled={isSubmitting}
                    >
                        Skip Email - Just Start Workout
                    </button>
                </div>
            </div>
        </div>
    );
};

export default UserDetailsModal;